module.exports = __webpack_public_path__ + "static/media/Assets-07-Camden-Market-halftone.89c36d7d.jpg";